import { anyOf, arrayOf, enumOf, objectOf } from "@altostra/type-validations";
import { boolean, nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

const availableResult = objectOf({
  status: enumOf("available"),
  component_name: string,
  conversion_type: anyOf(string, nullValidation),
  conversion_label: string,
  total_sends: number,
  reliability_threshold_sends: number,
  best_performing_active_variant: anyOf(string, nullValidation),
  best_performing_active_variant_index: anyOf(number, nullValidation),
  comparison_ready: boolean,
  variants: arrayOf(
    objectOf({
      index: number,
      text: string,
      status: enumOf("active", "deactivated"),
      sends: number,
      conversions: number,
      rate_percent: number,
      reliable: boolean,
    })
  ),
});

const unavailableResult = objectOf({
  status: enumOf("unavailable"),
  reason: string,
  total_sends: number,
});

export const isGetContentOptimizationPerformanceContextResult = anyOf(availableResult, unavailableResult);
